import { axiosInstances } from '../../utilities/axios/Instances/axios.instances';
const login = async reqBody => {
  return axiosInstances.withBaseUrl().post(`/auth/login`, reqBody);
};
const getCurrentUser = async () => {
  return axiosInstances.withAuthToken().get('/employees/current-employee');
};
export { login, getCurrentUser };
